module.exports = __webpack_public_path__ + "static/img/picture.fa1a2805.png";